import { Paper, Popper, styled } from '@mui/material';
import Notifications from '@mui/icons-material/Notifications';
import { Typography } from '@totalsoft/rocket-ui';

export const NotificationsLinks = styled(Notifications)(() => ({
  width: '24px',
  height: '24px',
  zIndex: '4'
}));

export const NotificationsSpan = styled('span')(({ theme }) => ({
  zIndex: '4',
  [theme.breakpoints.up('md')]: {
    position: 'absolute',
    top: '5px',
    border: '1px solid #FFF',
    right: '10px',
    fontSize: '9px',
    background: theme.palette.warning.main,
    color: '#FFFFFF',
    minWidth: '16px',
    height: '16px',
    borderRadius: '10px',
    textAlign: 'center',
    lineHeight: '14px',
    verticalAlign: 'middle',
    display: 'block'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    marginRight: '8px'
  }
}));

export const NotificationsPopper = styled(Popper)(options => ({
  pointerEvents: options.open ? 'none' : 'unset',
  [options.theme.breakpoints.down('sm')]: {
    zIndex: '1640',
    position: 'static',
    float: 'none',
    width: 'auto',
    marginTop: '0',
    backgroundColor: 'transparent',
    border: '0',
    boxShadow: 'none',
    color: 'black'
  }
}));

export const NotificationPaper = styled(Paper)(() => ({
  minWidth: 'fit-content',
  display: 'inline-block',
  float: 'right',
  margin: '0 20px 0 40px'
}));

export const DropdownItemDiv = styled('div')(() => ({
  cursor: 'pointer',
  maxWidth: '100%',
  fontSize: '13px',
  padding: '5px 0px 5px 5px',
  margin: '0 5px',
  borderRadius: '2px',
  position: 'relative',
  transition: 'all 150ms linear',
  display: 'block',
  clear: 'both',
  fontWeight: '400',
  height: 'fit-content',
  color: '#333',
  whiteSpace: 'normal',
  '&:hover': {
    backgroundColor: '#EEEEEE'
  }
}));

export const InLineDiv = styled('div')(() => ({
  display: 'inline-block',
  maxWidth: '92%'
}));

export const TypographyWidth = styled(Typography)(() => ({
  maxWidth: '100%',
  height: 'fit-content',
  width: 'fit-content'
}));
